'use client'

import { useEffect } from 'react'
import { otherApi } from '@/api'
import { Button, CruzIcon } from '@/components'

export default function ErrorComponent({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    otherApi.logError({
      name: error?.name,
      message: error?.message,
      stack: error?.stack,
      digest: error?.digest,
    })
  }, [error])

  return (
    <div className='flex flex-col items-center justify-center gap-2 w-full text-center'>
      <h2 className='font-2xl! pb-2! my-0!'>Something went wrong!</h2>
      <p className='font-light'>An unexpected error has occurred.</p>
      <Button className='rounded-full px-8 mt-4' onClick={() => reset()}>
        <CruzIcon.Refresh />
        Try again
      </Button>
    </div>
  )
}
